import { GA } from 'types';

export interface MenuClickData {
  type: GA.EventType.MENU_CLICK;
  itemText: GA.ItemText;
}

export interface MenuClickEvent {
  event: MenuClickData['type'];
  event_data: {
    action: GA.Action.CLICK;
    component_type: GA.ComponentType.MENU;
    item_text: MenuClickData['itemText'];
  };
}

const getMenuClickEvent = (data: MenuClickData): MenuClickEvent => {
  const { type, itemText } = data;

  return {
    event: type,
    event_data: {
      action: GA.Action.CLICK,
      component_type: GA.ComponentType.MENU,
      item_text: itemText,
    },
  };
};

export default getMenuClickEvent;
